import React from 'react';

const KPIReportCard = (props) => {
  const toneClass = props.color === '#d7f5df'
    ? 'kpi-card--up'
    : props.color === '#fadede'
      ? 'kpi-card--down'
      : '';

  return (
    <div className="col-lg-3 col-sm-6 kpi-col">
      <div
        className={`kpi-card h-100 ${toneClass}`}
        style={props.color && !toneClass ? { backgroundColor: props.color } : undefined}
      >
        <div className="kpi-card__body">
          <div className="kpi-card__value">{props.kpi}</div>
          <div className="kpi-card__label">{props.desc}</div>
        </div>
      </div>
    </div>
  );
};

export default KPIReportCard;
